import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ETLReportingSetDropdownOptions,
    ETLReportingSetReturnTypes,
    OperationSymbols
} from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-cxone-reporting-set-complex-numeric-field",
    templateUrl: "./complex-numeric-field.component.html",
    styleUrls: ["./complex-numeric-field.component.scss"],
})
export class CxoneReportingSetComplexNumericFieldComponent implements OnInit, OnDestroy {
    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() editExistItem = new EventEmitter();
    @Output() formChanged = new EventEmitter();
    @Output() validateSaveBtn = new EventEmitter();
    @Input() returnType: ETLReportingSetDropdownOptions;
    @Input() set parentData(data) {
        this._parentData = data;
        this._parentData.isValid = (data?.formulas?.length > 0) &&
            (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.DECIMAL_NUMBER);
    }
    _parentData: any;
    numericData: any;

    showFields = true;
    showFunctionOperatorField = false;
    operationSymbols = OperationSymbols;

    public addComponentsPlaceholder = "";
    public complexNumericForm = this.fb.group({
        childs: this.fb.array([]),
    });

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private fb: FormBuilder
    ) { }

    ngOnDestroy() {
        this.showAndHide(false);
    }

    public get childs() {
        return this.complexNumericForm.get("childs") as FormArray;
    }

    public get formControlCount() {
        return this.childs.length;
    }

    get parentData() {
        return this._parentData;
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.childs.push(
            this.fb.group({
                nestedDataFields: new FormArray([]), // For nested DataField components
            })
        );
        if (this.parentData) {
            this.parentData.isValid = (this.parentData?.formulas?.length > 0) &&
                (this.returnType && this.returnType.id === ETLReportingSetReturnTypes.DECIMAL_NUMBER);
        }
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.addComponentsPlaceholder = this.getLocalizationString(
                "Add_Components",
                "Add Components"
            );
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "ETL_Reporting_Set",
            key,
            defaultValue
        );
        return baseString;
    }

    public addNewField(): void {
        this.formulaClick();
        this.showAndHide(true);
    }

    showAndHide(hideDefaultForm) {
        this.showFunctionOperatorField = hideDefaultForm;
        if (document.getElementById('field-dropdown')) {
            document.getElementById('field-dropdown').hidden = hideDefaultForm;
        }
        if (document.getElementById('data-field-back-btn')) {
            document.getElementById('data-field-back-btn').hidden = hideDefaultForm;
        }
    }

    backBtn() {
        this.showAndHide(false);
    }

    addComplexNumericChild() {
        this.showAndHide(false);
        this.numericData.numericUniqueId = this.parentData.uniqueId;
        this.addChilds.emit(this.numericData);
    }

    public goBack(): void {
        this.back.emit(this.parentData);
    }

    editExist(item) {
        this.editExistItem.emit(item);
    }

    formulaClick() {
        if (!this.parentData.hasOwnProperty('formulas')) {
            this.parentData.formulas = [];
            this.parentData.formulas.push({
                functionType: '', operations: '',
                childs: [], numericType: 'expression'
            });
            this.numericData = this.parentData.formulas[0];
        }
        else {
            const numericType = this.parentData.formulas[this.parentData.formulas.length - 1].numericType === 'expression' ? 'operation' : 'expression';
            this.parentData.formulas.push({
                functionType: '', operations: '',
                childs: [], numericType
            });
            this.numericData = this.parentData.formulas[this.parentData.formulas.length - 1];
        }
    }

    editFormula(item) {
        this.numericData = item;
        this.showAndHide(true);
    }

    formValueChanged() {
        this._parentData.isValid = (this._parentData?.formulas?.length > 0) &&
            (this.returnType && this.returnType.id === ETLReportingSetReturnTypes.DECIMAL_NUMBER);
        this.formChanged.emit(this._parentData);
        this.validateSaveBtn.emit(this._parentData);
    }
}
